export enum CalendarView {
    timeGridDay = 'Day',
    timeGridWeek = 'Week',
    dayGridMonth = 'Month',
    listWeek = 'Schedule by Week',
    listMonth = 'Schedule by Month',
}
